import { useState } from "react";

import {
  Modal,
  Tabs,
  Tab,
  Box,
  Typography,
  Grid,
  CircularProgress,
} from "@material-ui/core";

import { columnTextField } from "utils/tables-utils";

import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import ImagePlaceholder from "components/Image/ImagePlaceholder";
import MaskAndValid from "utils/maskAndValid";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const a11yProps = (index) => {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
};

const LoadingData = () => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center">
      <CircularProgress size={20} color="inherit" />
    </Box>
  );
};

export default function DetailsModal({
  open,
  onClose,
  showcaseData,
  loadingDetails,
}) {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const uniqueClientes = showcaseData?.Clientes?.filter(
    (cliente, index, self) =>
      index === self.findIndex((c) => c.IdPessoaLoja === cliente.IdPessoaLoja),
  );

  const uniqueRepresentantes = showcaseData?.Representantes?.filter(
    (representante, index, self) =>
      index ===
      self.findIndex(
        (r) => r.IdPessoaRepresentante === representante.IdPessoaRepresentante,
      ),
  );

  const productsTableColumnModel = [
    columnTextField({
      dataField: "IdProduto",
      text: "Cód. Produto",
      align: "center",
    }),
    columnTextField({
      dataField: "DescricaoProduto",
      text: "Nome Comercial",
      align: "center",
      style: {
        maxWidth: "20vw",
        whiteSpace: "normal",
        wordBreak: "break-word",
      },
    }),

    columnTextField({
      dataField: "Ativo",
      text: "Ativo",
      align: "center",
      formatter: (_, row) => {
        return MaskAndValid.formatYesNo(row?.Ativo);
      },
    }),
    columnTextField({
      dataField: "Preco",
      text: "Preço",
      align: "center",
      formatter: (_, row) => `R$ ${MaskAndValid.maskPrice(row?.Preco)}`,
    }),
    columnTextField({
      dataField: "Foto",
      text: "Imagem",
      align: "center",
      formatter: (_, row) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <ImagePlaceholder
            src={row?.Foto}
            alt={`Imagem do produto ${row?.IdProduto}`}
            width="50px"
            height="50px"
            widthOnError="50px"
            heightOnError="50px"
          />
        </div>
      ),
    }),
  ];

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "80vw",
          height: "80vh",
          overflowY: "auto",
          bgcolor: "background.paper",
          boxShadow: 24,
        }}
      >
        <Tabs value={value} onChange={handleChange}>
          <Tab label="Dados gerais" {...a11yProps(0)} />
          <Tab label="Produtos" {...a11yProps(1)} />
          <Tab label="Representantes" {...a11yProps(2)} />
          <Tab
            label="Clientes"
            {...a11yProps(3)}
            disabled={showcaseData?.Status !== "PUBLICADO"}
          />
        </Tabs>
        <TabPanel value={value} index={0}>
          {loadingDetails ? (
            <LoadingData />
          ) : (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h4">
                  <b>Nome da Vitrine:</b> {showcaseData?.Nome}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h4">
                  <b>Descrição da Vitrine:</b> {showcaseData?.Descricao}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h4">
                  <b>Status da Vitrine:</b> {showcaseData?.Status}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h4">
                  <b>Data de criação da Vitrine:</b>{" "}
                  {showcaseData?.DataInclusaoFormat}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h4">
                  <b>Data de publicação da Vitrine:</b>{" "}
                  {showcaseData?.DataPublicacaoFormat}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h4">
                  <b>Data de vigência da Vitrine:</b>{" "}
                  {showcaseData?.FinalizarEstoque
                    ? "Até finalizar o estoque"
                    : `${showcaseData?.DataVigenciaInicioFormat} - ${showcaseData?.DataVigenciaFimFormat}`}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h4">
                  <b>Criada por:</b> {showcaseData?.NomeUsuario}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h4">
                  <b>Publicada por:</b> {showcaseData?.NomeUsuarioPublicacao}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h4">
                  <b>Data de publicação:</b>{" "}
                  {showcaseData?.DataPublicacaoFormat}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h4">
                  <b>Tabela de preço:</b> {showcaseData?.CodigoTabelaPreco}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h4">
                  <b>Condição de pagamento:</b>{" "}
                  {showcaseData?.CondicaoPagamento?.Politica}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h4">
                  <b>Percentual de desconto:</b>{" "}
                  {showcaseData?.CondicaoPagamento?.PercentualDesconto}%
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h4">
                  <b>Valor mínimo:</b> {showcaseData?.ValorMinimo}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h4">
                  <b>Duplicata mínima:</b> {showcaseData?.DuplicataMinima}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h4">
                  <b>Quantidade mínima por pedido:</b>{" "}
                  {showcaseData?.QuantidadeMinimaPedido}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h4">
                  <b>Por linha:</b> {showcaseData?.PorLinha ? "Sim" : "Não"}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h4">
                  <b>Por pedido:</b> {showcaseData?.PorPedido ? "Sim" : "Não"}
                </Typography>
              </Grid>
            </Grid>
          )}
        </TabPanel>
        <TabPanel value={value} index={1}>
          {loadingDetails ? (
            <LoadingData />
          ) : (
            <ToolkitTable
              keyField="Codigo"
              dataTable={showcaseData?.Itens}
              columnModel={productsTableColumnModel}
              pagination={{
                options: [25, 50, 100],
                defaultOption: 25,
              }}
              allowEmpty
            />
          )}
        </TabPanel>
        <TabPanel value={value} index={2}>
          {loadingDetails ? (
            <LoadingData />
          ) : (
            uniqueRepresentantes?.map((representative, index) => (
              <Typography
                variant="h4"
                key={representative.IdPessoaRepresentante}
              >
                {index + 1}. {representative.NomeRepresentante} -{" "}
                {MaskAndValid.maskCNPJ(representative.CnpjCpfRepresentante)}
              </Typography>
            ))
          )}
        </TabPanel>
        <TabPanel value={value} index={3}>
          {loadingDetails ? (
            <LoadingData />
          ) : (
            uniqueClientes?.map((cliente, index) => (
              <Typography variant="h4" key={cliente.IdPessoaLoja}>
                {index + 1}. {cliente.NomeLoja} -{" "}
                {MaskAndValid.maskCNPJ(cliente.CnpjCpfLoja)}
              </Typography>
            ))
          )}
        </TabPanel>
      </Box>
    </Modal>
  );
}
